// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Bj","hoverContainer":"e_Cj","tooltip":"e_Dj","active":"e_Ej","head":"e_Fj","text":"e_Gj"};